<template>
    <div id="Help">
        <div class="help_wrap">
            <div class="com_header">
                <div class="com_header_c">
                    帮助中心
                </div>
            </div>
            <div class="help_notice">
                <div class="notice_wrap">
                    <p>联系客服支持</p>
                    <p>如果你在游戏过程中遇到任何问题，请联系客服支持</p>
                </div>
            </div>
            <div class="common_tabs">
                <div class="tab_item" :class="{ 'active': help_tab_index == 1 }" @click="ChangeTabs(1)">
                    <div class="icon">
                        <img src="@/assets/images/bag/get-n.png" alt="">
                    </div>
                    用户协议
                </div>
                <div class="tab_item" :class="{ 'active': help_tab_index == 2 }" @click="ChangeTabs(2)">
                    <div class="icon">
                        <img src="@/assets/images/bag/get-n.png" alt="">
                    </div>
                    隐私条款
                </div>
                <div class="tab_item" :class="{ 'active': help_tab_index == 3 }" @click="ChangeTabs(3)">
                    <div class="icon">
                        <img src="@/assets/images/bag/get-n.png" alt="">
                    </div>
                    预防公告
                </div>
            </div>
            <div class="help_main">
                <template v-if="help_tab_index == 1">
                    <UserAgreement></UserAgreement>
                </template>
                <template v-else-if="help_tab_index == 2">
                    <Privacy></Privacy>
                </template>
                <template v-else-if="help_tab_index == 3">
                </template>


            </div>

        </div>

    </div>
</template>

<script>
import Privacy from '../../UnpackingRules/Privacy.vue'
import UserAgreement from '../../UnpackingRules/UserAgreement.vue'

export default {
    name: 'Help',
    data() {
        return {
            ///选中的页签
            help_tab_index: 1,  ///1:用户协议  2:隐私条款  3:预防公告

        }

    },

    components: {
        Privacy,
        UserAgreement,
    },
    methods: {
        ///页签切换
        ChangeTabs(tab) {
            this.help_tab_index = tab;
        },


    }

}
</script>

<style lang="scss">
#Help {
    .help_wrap {
        box-sizing: border-box;
        padding-top: 3px;
        width: 100%;
        min-height: 500px;
        padding-bottom: 50px;
        display: flex;
        align-items: center;
        flex-direction: column;

        .com_header {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 5px;
            margin-bottom: 5px;

            .com_header_c {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 197px;
                height: 105px;
                background: url(../../../assets/images/MyExtension/header_bg.png) center no-repeat;
                background-size: 100% 100%;
                color: #fff;
                font-size: 24px;
            }
        }

        .help_notice {
            display: flex;
            width: 1440px;
            height: 193px;
            background: url(../../../assets/images/MyExtension/help_bg.png) center no-repeat;
            padding-left: 150px;
            box-sizing: border-box;

            .notice_wrap {
                display: flex;
                flex-direction: column;
                margin-top: 45px;

                p {
                    &:first-child {
                        color: #e6e6f1;
                        font-size: 22px;
                        font-weight: 700
                    }

                    &:last-child {
                        color: #8c8da6;
                        font-size: 17px;
                        font-weight: 400
                    }
                }
            }
        }

        .common_tabs {
            background-color: #111324;
            font-size: 16px;
            color: #fff;
            display: flex;
            height: 80px;
            line-height: 80px;
            align-items: center;
            text-align: center;
            justify-content: flex-start;
            width: 1410px;
            margin: 0 auto;
            box-sizing: border-box;

            .tab_item {
                flex: 1;
                cursor: pointer;
                border-bottom: solid 1px #4b56bc00;
                .icon {
                    display: inline-block;
                    vertical-align: middle;
                    fill: currentColor;
                    position: relative;
                    top: -25px;
                    width: 20px;
                    height: 20px;
                    color: #9ca1c7;
                    font-size: 16px;
                    text-transform: uppercase;
                    flex-shrink: 0;
                }

                &.active {
                    color: #fff;
                    border-bottom: solid 1px #4b56bc;
                }
            }
        }

        .help_main {
            display: flex;
            flex-direction: column;
            width: 100%;
            min-height: 500px;

        }
    }


}</style>